"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightWithDrillSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var drill_1 = require("../../../../drill");
var DashboardInsight_1 = require("./DashboardInsight");
/**
 * @internal
 */
exports.DashboardInsightWithDrillSelect = function (props) {
    var widget = props.widget, onDrillDown = props.onDrillDown, onDrillToInsight = props.onDrillToInsight, onDrillToAttributeUrl = props.onDrillToAttributeUrl, onDrillToCustomUrl = props.onDrillToCustomUrl, onDrillToDashboard = props.onDrillToDashboard;
    return (react_1.default.createElement(drill_1.WithDrillSelect, { widgetRef: widget.ref, insight: props.insight, onDrillDownSuccess: onDrillDown, onDrillToInsightSuccess: onDrillToInsight, onDrillToAttributeUrlSuccess: onDrillToAttributeUrl, onDrillToCustomUrlSuccess: onDrillToCustomUrl, onDrillToDashboardSuccess: onDrillToDashboard }, function (_a) {
        var onDrill = _a.onDrill;
        return react_1.default.createElement(DashboardInsight_1.DashboardInsight, tslib_1.__assign({}, props, { onDrill: onDrill }));
    }));
};
//# sourceMappingURL=DashboardInsightWithDrillSelect.js.map